import { ApiDataResponse } from '../../libs/IdeLink.Web.Common/src/services/api/ApiResponse';


//! IMAGE, PDF
export interface MediaItem {
    readonly id?: string;
    readonly url: string;
}

export interface VideoDuration {
    readonly ticks: number;
    readonly days: number;
    readonly hours: number;
    readonly milliseconds: number;
    readonly minutes: number;
    readonly seconds: number;
    readonly total_days: number;
    readonly total_hours: number;
    readonly total_milliseconds: number;
    readonly total_minutes: number;
    readonly total_Seconds: number;
}

export interface UploadedVideoItem {
    readonly video_id: string;
    readonly image_id: string;
    readonly image_url: string;
    readonly duration: string;//VideoDuration;
}

export type MediaItemResponse = ApiDataResponse<MediaItem>

export type UploadedVideoItemResponse = ApiDataResponse<UploadedVideoItem>;

export class MediaItemHelper {
    public static toMediaItem(id: string = '', url: string = ''): MediaItem | undefined {
        return url ? { id, url } : undefined;
    }
}